import React from 'react';
import {
  Box,
  Text,
  constants,
  Icon
} from '@match/react-component-library';
import {
  SyntheticButton
} from '../../../app-core-components';
import { PageLayout } from '../../layouts';

const { SPACE, TYPOGRAPHY, FONT_WEIGHT } = constants;

interface Props {
  name?: string;
}

class SuccessPage extends React.Component<Props> {
  render() {
    return (
      <PageLayout>
        <Box
          textAlign="center"
          paddingBottom={SPACE.XXXLARGE}
        >
          <Icon 
            name="circlecheck" 
            size="xxxlarge"
            color="primary1" 
          />
        </Box>
        <Box
        textAlign="center"
        paddingBottom={SPACE.XLARGE}
        >
          <Text
            fontSize={TYPOGRAPHY.H4}
            fontWeight={FONT_WEIGHT.BOLD}
          >
          Now you're in{this.props.name ? ` ${this.props.name}`: undefined}!</Text>
        </Box>
        <Box
          paddingBottom={SPACE.XXXLARGE}
        >
        <Text
          textAlign="left"
          fontSize={TYPOGRAPHY.LARGEBODY}
          lineHeight="1.8"
        >
            • Make connections with local singles<br/>
            • Send and receive unlimited messages<br/>
            • Get priority access to Match Events<br/>

          </Text>
        </Box>
        <Box
          width="100%"
          paddingTop={SPACE.XXXLARGE}
        >
          <a href="https://www.match.com/search">
            <SyntheticButton
              size="xlarge"
              color='ctaPrimary'
              fullWidth
            >
              Get started
            </SyntheticButton>
          </a>
        </Box>
      </PageLayout>
    );
  }
}

export default SuccessPage;
